module.exports = __webpack_public_path__ + "img/preview_doc_active.c85a7e6b.svg";